import { projectService } from '@/services/project/project-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type { models } from 'cesg-shared';

export const useProjectMetaDataMutation = ({
  projectId,
}: {
  projectId: string;
}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['projectService', 'put', projectId],
    mutationFn: (body: models.UpdateProjectBody) =>
      projectService.put(projectId, body),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: projectKeys.details({ projectId }),
      }),
  });
};
